var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 7.8125C12.375 7.50184 12.6268 7.25 12.9375 7.25H14.0625C14.3732 7.25 14.625 7.50184 14.625 7.8125V8.9375C14.625 9.24816 14.3732 9.5 14.0625 9.5H12.9375C12.6268 9.5 12.375 9.24816 12.375 8.9375V7.8125Z",
    fill: "#16B054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.8125C9 7.50184 9.25184 7.25 9.5625 7.25H10.6875C10.9982 7.25 11.25 7.50184 11.25 7.8125V8.9375C11.25 9.24816 10.9982 9.5 10.6875 9.5H9.5625C9.25184 9.5 9 9.24816 9 8.9375V7.8125Z",
    fill: "#16B054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 11.1875C3.375 10.8768 3.62684 10.625 3.9375 10.625H5.0625C5.37316 10.625 5.625 10.8768 5.625 11.1875V12.3125C5.625 12.6232 5.37316 12.875 5.0625 12.875H3.9375C3.62684 12.875 3.375 12.6232 3.375 12.3125V11.1875Z",
    fill: "#16B054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.1875C6.75 10.8768 7.00184 10.625 7.3125 10.625H8.4375C8.74816 10.625 9 10.8768 9 11.1875V12.3125C9 12.6232 8.74816 12.875 8.4375 12.875H7.3125C7.00184 12.875 6.75 12.6232 6.75 12.3125V11.1875Z",
    fill: "#16B054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 0.5C4.24816 0.5 4.5 0.75184 4.5 1.0625V1.625H13.5V1.0625C13.5 0.75184 13.7518 0.5 14.0625 0.5C14.3732 0.5 14.625 0.75184 14.625 1.0625V1.625H15.75C16.9926 1.625 18 2.63236 18 3.875V16.25C18 17.4926 16.9926 18.5 15.75 18.5H2.25C1.00736 18.5 0 17.4926 0 16.25V3.875C0 2.63236 1.00736 1.625 2.25 1.625H3.375V1.0625C3.375 0.75184 3.62684 0.5 3.9375 0.5ZM1.125 5V16.25C1.125 16.8713 1.62868 17.375 2.25 17.375H15.75C16.3713 17.375 16.875 16.8713 16.875 16.25V5H1.125Z",
    fill: "#16B054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.84c5a347178f14d6a60d1f43855209be.svg";
export { ForwardRef as ReactComponent };